import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons/faTimes";
import {ConditionGroup} from "./ConditionGroup";
import './ConditionLine.css';
import { ConditionLineOptions } from "./ConditionBuilder";
import './ConditionLine.css';
import {ComparatorBase} from "./Comparators/ComparatorBase";
import {ComparatorFactory} from "./Comparators/ComparatorFactory";
export class ConditionLine extends React.Component<ConditionLineProps, ConditionLineState> {
    static defaultProps: Partial<ConditionLineProps> = {};

    public LastComparator:ComparatorBase;
    constructor(props: ConditionLineProps) {
        super(props);
        this.state = {
            ShowValidations:false
        };
        this.Refresh=this.Refresh.bind(this);
    }

    public get Fields(){
        return this.props.ConditionGroup.props.ConditionBuilder.props.Fields;
    }
    private Refresh()
    {
        this.forceUpdate();
    }
    componentDidMount(): void {

    }

    componentWillUnmount(): void {

    }


    public render() {
        let fields=this.Fields;
        if(fields==null)
            return (
                <p>Please select a form first</p>
            )
        let comparator=ComparatorFactory.GetComparator(this);
        this.LastComparator=comparator;
        if(comparator==null)
            return null;
        comparator.SanitizeValue();

        return comparator.Render();
    }

    public get ConditionLineOptions(){
        return this.props.ConditionLineOptions;
    }


    public get ConditionGroup(){
        return this.props.ConditionGroup;
    }

    Validate() {
        let validation=false;
        if(this.LastComparator!=null)
             validation= this.LastComparator.Validate();
        if(validation===false)
            return false;

        return validation;

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ConditionLineProps {
    ConditionGroup:ConditionGroup;
    ConditionLineOptions: ConditionLineOptions;
    OnAddLine: (x: ConditionLineOptions) => void;
    OnRemoveLine: (x: ConditionLineOptions) => void;
    OnFieldChanged:()=>void;
}


interface ConditionLineState {
    ShowValidations:boolean;
}

//#endregion "My Region"